import moment from 'moment'

// Definição corrente da tela (setada por crudDinamico.actions ao carregar a chave).
// O validate do crudFactory recebe apenas o record, então a definição vive aqui.
let definicaoCorrente = null

export function setDefinicaoCorrente(definicao) {
  definicaoCorrente = definicao
}

export function getDefinicaoCorrente() {
  return definicaoCorrente
}

const isVazio = (valor) =>
  valor === null || valor === undefined || valor === '' || (Array.isArray(valor) && valor.length === 0)

// Valida a partir de campos[].obrigatorio e converte datas para o formato de transporte
// (date -> yyyy-MM-dd, datetime -> ISO-8601). Lookups já estão como oid no record.
export function validate(record) {
  const errors = []
  const payload = Object.assign({}, record)

  const campos = (definicaoCorrente && definicaoCorrente.campos) || []
  campos.forEach((campo) => {
    const valor = payload[campo.nome]
    // boolean nunca é "ausente": null/undefined/'' vale false (espelha o CrudDinamicoValueBinder do BE)
    if (campo.tipo === 'boolean') {
      payload[campo.nome] = valor === true
      return
    }
    if (campo.obrigatorio && isVazio(valor)) {
      errors.push({ field: campo.nome, message: `O campo "${campo.label}" é obrigatório` })
      return
    }
    if (isVazio(valor)) {
      payload[campo.nome] = null
      return
    }
    if (campo.tipo === 'date') {
      payload[campo.nome] = moment(valor).format('YYYY-MM-DD')
    } else if (campo.tipo === 'datetime') {
      payload[campo.nome] = moment(valor).toISOString()
    }
  })

  const result = {
    ok: errors.length === 0,
    errors,
    record: payload,
  }

  return new Promise((resolve, reject) => {
    const action = result.ok ? resolve : reject
    return action(result)
  })
}
